import { Select } from 'antd';
import { useGlobalContext } from '../../../context/GlobalContext';
import { ProductType } from '../../../enum/materiais/product-type.enum';
import { useTranslation } from 'react-i18next';

export default function useSelectTypeMaterial() {
  const { usuario } = useGlobalContext();
  const { t } = useTranslation('materiais');

  const userHasAcessoB2CAndB2B = usuario?.acessoB2c && usuario?.acessoB2b;
  const userHasOnlyAcessoB2B = usuario?.acessoB2b && !usuario?.acessoB2c;
  const userHasOnlyAcessoB2C = usuario?.acessoB2c && !usuario?.acessoB2b;

  const selectTypeMaterial = (): JSX.Element => {
    if (userHasAcessoB2CAndB2B)
      return (
        <>
          {/* <Select.Option value={ProductType.Curso}>{t('materiais:curso')}</Select.Option> */}
          <Select.Option value={ProductType.Curriculo}>{t('materiais:curriculoHub')}</Select.Option>
          <Select.Option value={ProductType.ProdutoEscola}>
            {t('materiais:produtoEscola')}
          </Select.Option>
        </>
      );

    if (userHasOnlyAcessoB2C)
      return (
        <Select.Option value={ProductType.Curriculo}>{t('materiais:curriculoHub')}</Select.Option>
      );

    if (userHasOnlyAcessoB2B)
      return (
        <Select.Option value={ProductType.ProdutoEscola}>
          {t('materiais:produtoEscola')}
        </Select.Option>
      );
  };

  return {
    selectTypeMaterial: selectTypeMaterial(),
  };
}
